type Props = {
  toggleSelector: string
}

export default function toggleReveal(
  el: HTMLElement,
  { toggleSelector }: Props,
) {
  const toggle = el.querySelector<HTMLButtonElement>(toggleSelector)

  if (!toggle) {
    return
  }

  toggle.addEventListener("click", () => {
    const ariaExpanded = toggle.getAttribute("aria-expanded")
    if (ariaExpanded === "true") {
      toggle.setAttribute("aria-expanded", "false")
    } else {
      toggle.setAttribute("aria-expanded", "true")
    }
  })

  const buttonObserver = new MutationObserver(mutationList => {
    mutationList.forEach(mutation => {
      if (mutation.type === "attributes") {
        const ariaExpanded = toggle.getAttribute("aria-expanded")
        if (ariaExpanded === "true") {
          el.setAttribute("data-reveal", "true")
        } else {
          el.setAttribute("data-reveal", "false")
        }
      }
    })
  })

  buttonObserver.observe(toggle, { attributes: true })
}
